<script>

import { Line } from 'vue-chartjs';
import { getStyle, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities';
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips';
import { mapGetters, mapActions } from 'vuex';

let history;
let sizeGraffic;

export default {

  computed: {
    ...mapGetters(['visitasPorAno', 'sizeGrafficVisitasPorAno']),
  },
  methods: mapActions(['buscarHistoricoVisitas']),
  async created() {
    await this.mounted;
  },

  extends: Line,
  props: ['height'],

  async mounted() {
    await this.buscarHistoricoVisitas();
    history = this.visitasPorAno;
    sizeGraffic = this.sizeGrafficVisitasPorAno;

    const brandInfo = getStyle('--info') || '#73cee1';


    this.renderChart({
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May',
        'Jun', 'jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      datasets: [
        {
          label: 'Number of visits per month',
          backgroundColor: hexToRgba(brandInfo, 20),
          borderColor: brandInfo,
          pointHoverBackgroundColor: '#fff',
          borderWidth: 2,
          data: history,
        },

      ],
    }, {
      tooltips: {
        enabled: false,
        custom: CustomTooltips,
        intersect: true,
        mode: 'index',
        position: 'nearest',
        callbacks: {
          labelColor(tooltipItem, chart) {
            return {
              backgroundColor:
              chart.data.datasets[tooltipItem.datasetIndex].borderColor,
            };
          },
        },
      },
      maintainAspectRatio: false,
      legend: {
        display: false,
      },
      scales: {
        xAxes: [{
          gridLines: {
            drawOnChartArea: false,
          },
        }],
        yAxes: [{
          ticks: {
            beginAtZero: true,
            maxTicksLimit: 5,
            stepSize: Math.ceil(250 / 5),
            max: sizeGraffic,
          },
          gridLines: {
            display: true,
          },
        }],
      },
      elements: {
        point: {
          radius: 0,
          hitRadius: 10,
          hoverRadius: 4,
          hoverBorderWidth: 3,
        },
      },
    });
  },
};
</script>
